import React from 'react';
import { useGetActiveVisualisationSettings } from 'utils/hooks/visualisation/getActiveVisualisationSettings';
import { defaultWaterfallDataSettings, defaultWaterfallViewSettings } from 'store/reducers/visualisations/constants';
import { DefaultViewSettings } from 'modules/settingsContainer/common/view/DefaultViewSettings';
import { BooleanTipsSettings } from 'modules/settingsContainer/common/view/BooleanTipsSettings';
import { AxisSettings } from 'modules/settingsContainer/common/view/AxisSettings';
import {
  onAxisIncisionChange,
  onAxisIndicatorChange,
  onChangeHorizontalZoomChange,
  onChangePaddingVisualisation,
  onChangeVerticalZoomChange,
  onIncisionSelectorPositionChange,
  onLegendSettingsChange,
  onShowTipsChange,
} from 'modules/visualisations/Waterfall/settings/ViewTab/constants';
import { ExtendedSettings } from 'modules/settingsContainer/common/view/ExtendedSettings';
import { IncisionsSelectorPositionSettings } from 'modules/settingsContainer/common/IncisionsSelectorPositionSettings';
import { PaddingVisualisationSettings } from 'modules/settingsContainer/common/data/PaddingVisualisationSettings';
import { ZoomSettings } from 'modules/settingsContainer/common/view/VerticalZoomSettings';
import { showLegendTitle } from 'modules/settingsContainer/common/view/LegendSettings/constants';
import { onVisibleIncisionSelectorChange } from '../../../Heatmap/settings/ViewTab/constants';
import SubSection from 'shared/ui/subSection';
import { MainContainerSettings } from 'modules/settingsContainer/MainContainerSettings';

export const ViewTab = () => {
  const { viewSettings, positionConfig } = useGetActiveVisualisationSettings({
    defaultView: defaultWaterfallViewSettings,
    defaultData: defaultWaterfallDataSettings,
  });

  return (
    <>
      <DefaultViewSettings
        SecondSlot={
          <>
            <IncisionsSelectorPositionSettings
              value={viewSettings.incisionSelectorPosition}
              onChange={onIncisionSelectorPositionChange}
              onChangeVisible={onVisibleIncisionSelectorChange}
              isVisible={viewSettings.isVisible}
            />
            <ExtendedSettings title={showLegendTitle} value={viewSettings.legendSettings} onChange={onLegendSettingsChange} />
          </>
        }
        ThirdSlot={
          <>
            <BooleanTipsSettings value={viewSettings.showTips} onChange={onShowTipsChange} />{' '}
            <AxisSettings
              value={viewSettings.axisIncisionSettings}
              onChange={onAxisIncisionChange}
              titleText="Ось разрезов"
              type="incision"
              disabledOrderValue
            />
            <AxisSettings
              value={viewSettings.axisIndicatorSettings}
              onChange={(axisIndicatorSettings) => onAxisIndicatorChange(axisIndicatorSettings)}
              titleText="Ось показателей"
              type="indicator"
            />
            <MainContainerSettings titleText="Приближение">
              <SubSection>
                <ZoomSettings
                  title="Приближение по горизонтали"
                  value={viewSettings.horizontalZoom}
                  onChange={onChangeHorizontalZoomChange}
                />
              </SubSection>
              <SubSection>
                <ZoomSettings
                  title="Приближение по вертикали"
                  value={viewSettings.verticalZoom}
                  onChange={onChangeVerticalZoomChange}
                />
              </SubSection>
            </MainContainerSettings>
            <PaddingVisualisationSettings value={viewSettings.visualisationPaddings} onChange={onChangePaddingVisualisation} />
          </>
        }
        viewSettings={viewSettings}
        positionConfig={positionConfig}
      />
    </>
  );
};
